import React from 'react';

import { errorMessages } from 'src/translates/errorMessages';

import { DefaultErrorOverlay } from '@ael/shared-components-library/student-shell';
import { useIntl } from 'react-intl';

export const UnknownLoadingErrorOverlay = () => {
  const intl = useIntl();

  return (
    <DefaultErrorOverlay
      title={intl.formatMessage(errorMessages.unknownLoadingTitle)}
      description={<p>{intl.formatMessage(errorMessages.unknownLoadingDescription)}</p>}
    />
  );
};
